import React from 'react';

const STATUS_MAP = {
  active: 'active',
  expired: 'expired',
  suspended: 'suspended',
  revoked: 'revoked',
  pending: 'pending',
  pagada: 'pagada',
  pendiente: 'pendiente',
  validada: 'validada',
  devuelta: 'devuelta',
  aceptado: 'aceptado',
  rechazado: 'rechazado',
  borrador: 'draft',
  enviado: 'enviado',
  caducado: 'caducado',
  draft: 'draft',
  // Facturas (estados adicionales)
  parcial: 'pendiente',
  anulada: 'expired',
  proforma: 'draft',
  // Proyectos (clave con guion bajo y etiqueta con espacios)
  a_la_espera: 'pending',
  'a la espera': 'pending',
  en_proceso: 'enviado',
  'en proceso': 'enviado',
  finalizado: 'pagada',
  // Bolsas de horas
  activa: 'active',
  consumida: 'draft',
  suspendida: 'suspended',
  // Tickets de soporte
  abierto: 'pending',
  esperando_cliente: 'pendiente',
  resuelto: 'pagada',
  cerrado: 'draft',
};

// Etiqueta concreta por estado de entrada (cuando difiere de la clase mapeada)
const STATUS_LABELS = {
  parcial: 'Parcial',
  anulada: 'Anulada',
  proforma: 'Proforma',
  a_la_espera: 'A la espera',
  'a la espera': 'A la espera',
  en_proceso: 'En proceso',
  'en proceso': 'En proceso',
  finalizado: 'Finalizado',
  activa: 'Activa',
  consumida: 'Consumida',
  suspendida: 'Suspendida',
  abierto: 'Abierto',
  esperando_cliente: 'Esperando tu respuesta',
  resuelto: 'Resuelto',
  cerrado: 'Cerrado',
};

const LABELS = {
  active: 'Activa',
  expired: 'Expirada',
  suspended: 'Suspendida',
  revoked: 'Revocada',
  pending: 'Pendiente',
  pagada: 'Pagada',
  pendiente: 'Pendiente',
  validada: 'Validada',
  devuelta: 'Devuelta',
  aceptado: 'Aceptado',
  rechazado: 'Rechazado',
  enviado: 'Enviado',
  caducado: 'Caducado',
  draft: 'Borrador',
};

const StatusBadge = ({ status }) => {
  const key = String(status || '').toLowerCase().trim();
  const mapped = STATUS_MAP[key];
  // Estado desconocido: muestra el texto original con estilo neutro (no lo enmascara como Borrador)
  if (!mapped) return <span className="cp-badge cp-badge-draft">{status || '-'}</span>;
  const label = STATUS_LABELS[key] || LABELS[mapped] || status;
  return <span className={`cp-badge cp-badge-${mapped}`}>{label}</span>;
};

export default StatusBadge;
